export default "__VITE_ASSET__D6pY_C2$__"